module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_1.76f9b47b.png";